import useLog from '@features/logs/hooks/useLog'
import { Button, Heading, theme, Warning } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { Modal } from 'antd'
import { showToast } from 'common/utils'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import {
  ConfirmationModalContent,
  ConfirmationModalTitleContainer,
  ModalFooter
} from '../commonStyledComponents'

type RestoreIncidentModalProps = {
  open: boolean
  setIsRestoringIncident: (value: boolean) => void
  logId: string
  refetch: () => void
}
const RestoreIncidentModal = ({
  open,
  setIsRestoringIncident,
  logId,
  refetch
}: RestoreIncidentModalProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  const { restoreLog, isRestoreLoading } = useLog({
    logId,
    onRestoreSuccess: () => {
      setIsRestoringIncident(false)
      showToast({
        title: t(incidentReportsConstants.LOG_RESTORED)
      })
      refetch()
    }
  })

  const handleRestoreLog = async () => {
    try {
      await restoreLog()
    } catch {
      showToast({
        title: t(generalConstants.ERROR, { ns: NAMESPACE.GENERAL }),
        type: 'error'
      })
    }
  }
  return (
    <Modal
      closable={false}
      width={546}
      open={open}
      footer={[
        <ModalFooter>
          <Button onClick={() => setIsRestoringIncident(false)}>
            {t(incidentReportsConstants.CANCEL)}
          </Button>
          <Button
            onClick={handleRestoreLog}
            isLoading={isRestoreLoading}
            variant="primary"
          >
            {t(incidentReportsConstants.RESTORE)}
          </Button>
        </ModalFooter>
      ]}
    >
      <ConfirmationModalContent>
        <ConfirmationModalTitleContainer>
          <Warning color={theme.color.status.warning} size={24} />
          <Heading level={4}>
            {t(incidentReportsConstants.RESTORE_MODAL_TITLE)}
          </Heading>
        </ConfirmationModalTitleContainer>
        <Divider />
        <Text> {t(incidentReportsConstants.RESTORE_MODAL_DESCRIPTION)}</Text>
        <Divider />
      </ConfirmationModalContent>
    </Modal>
  )
}

export default RestoreIncidentModal
